<template>
  <v-container>

    <v-layout row class="mt-3">
      <v-flex xs12 md10 lg8 offset-md1 offset-lg2>
        <h2>{{ $t("your_records") }}</h2>
      </v-flex>
    </v-layout>
    <v-layout row class="mt-1 mb-1" v-if="filter_guests.length">
      <v-flex xs12 md10 lg8 offset-md1 offset-lg2 class="pa-3 white" elevation-15>
        <v-layout>
          <v-flex xs12>
            <b><v-text-field
              :label="$t('search_your_guests')"
              single-line
              full-width
              :hide-details="true"
              prepend-icon="search"
              append-icon="clear"
              :append-icon-cb="clearFilter"
              v-model="filter"
              @input="onFilter"
              ref="focus"
            ></v-text-field></b>
          </v-flex>
          <!-- <v-flex xs1 class="mt-3">
            <v-progress-circular indeterminate class="primary--text" v-if="filtering"></v-progress-circular>
          </v-flex> -->
        </v-layout>
      </v-flex>
    </v-layout>



    <!-- Search results -->
    <v-layout row v-show="loading" class="mt-3">
      <v-flex xs12 text-xs-center>
        <v-progress-circular indeterminate :size="60" :width="4" class="primary--text"></v-progress-circular>
      </v-flex>
    </v-layout>

    <v-layout row v-show="!loading">
      <v-flex xs12 class="text-xs-center" v-if="!filter_guests.length">
        <v-container class="text--center">
          {{ $t("no_records_entered") }}
        </v-container>
      </v-flex>
      <v-flex xs12 v-else>
        <v-layout class="primary--text my-3">
          <v-flex xs6 class="text-xs-left">
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <strong class="text-xs-right">{{ $t("total") }} {{filter_guests.length}}</strong>
          </v-flex>
        </v-layout>
        <guests-list :guests="filter_guests" :editable="true"></guests-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import GuestsList from '../Guests/GuestsList'
  import * as utils from '../../utils'
  import _ from 'lodash'

  export default {
    components: {
      GuestsList
    },

    data () {
      return {
        loading: false,
        filtering: false,
        filter: '',
        guests: [],
        filter_guests: []
      }
    },

    created () {
      var self = this
      self.loading = true

      utils.HTTP.get('profile/guests')
        .then(response => {
          self.guests = response.data
          self.filter_guests = self.guests
          self.loading = false
        })
    },

    mounted () {
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    },

    methods: {
      onFilter: _.debounce(function (e) {
        this.doFilter(this.filter)
      }, 300),

      clearFilter () {
        this.filter = ''
        this.doFilter('')
      },

      doFilter (value) {
        if (value === '') {
          this.filter_guests = this.guests
          return
        }
        this.filtering = true
        this.filter_guests = _.filter(this.guests, g => {
          return g.last_name.indexOf(value) !== -1 ||
          (g.document_id && g.document_id.indexOf(value) !== -1) ||
          (g.visum && g.visum.indexOf(value) !== -1) ||
          (g.phone && g.phone.indexOf(value) !== -1) ||
          (g.email && g.email.indexOf(value) !== -1) ||
          (g.company && g.company.indexOf(value) !== -1)
        })
        this.filtering = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/User/ProfileGuests.vue